import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import RoundButton from "core/Components/Buttons/RoundButton";
import Cart from "core/Components/Icons/Cart";

type Props = {
    addToCartHandler: () => void,
    disabled?: boolean,
};

const ItemAddToCartButton: React.FC<Props> = ({
    addToCartHandler,
    disabled = false,
}) => {
    const theme: Theme = useTheme();

    const style = css`
        position: relative;
        display: flex;
        justify-content: center;
        margin-top: 76px;

        ${theme.breakpoints.only('lg')} {
            margin-top: 38px;
        }

        ${theme.breakpoints.between('sm', 'md')} {
            margin-top: 41px;
        }
        
        ${theme.breakpoints.down('xs')} {
            margin-top: 32px;
        }
    `;

    const buttonStyle = css`
        display: flex;
        align-items: center;
    `;

    const iconStyle = css`
            width: 30px;
            height: 30px;
        `;
    
    const textStyle = css`
        margin-left: 22px;
        font-size: 24px;
    `;

    return (
        <div css={style}>
            <RoundButton
                buttonWidth={240}
                buttonHeight={57}
                buttonBorderRadius={30}
                buttonSidePadding={5}
                textColour={'black'}
                backgroundColour={'white'}
                buttonHoverColour={theme.colours.gold}
                useTextHover={false}
                onButtonClick={addToCartHandler}
                disabled={disabled}
            >
                <div css={buttonStyle}>
                    <Cart
                        css={iconStyle}
                        colour={theme.colours.curiousBlue}
                    />
                    <span css={textStyle}>Add to cart</span>
                </div>
            </RoundButton>
        </div>
    );
};

export default ItemAddToCartButton;